import { render } from "./loader.vue?vue&type=template&id=1caf1124&scoped=true&ts=true"
import script from "./loader.vue?vue&type=script&lang=ts"
export * from "./loader.vue?vue&type=script&lang=ts"

import "./loader.vue?vue&type=style&index=0&id=1caf1124&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1caf1124"]])

export default __exports__